import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,{staticClass:"auth-layout",attrs:{"id":"app"}},[_c(VContent,[_c('myHeader'),_c(VContainer,{attrs:{"fluid":"","fill-height":""}},[_c('router-view')],1)],1),_c('notificationBar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }